import React, { useState, useEffect } from 'react'

import {
    CButton, CCard, CBadge,
    CButtonGroup,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CImage,
    CCallout
} from 'compat/coreui';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector, connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postData, getData } from '../../helpers/api';

export default function Posts(props) {
    const [profileImg, setProfileImage] = useState("");
    const [selectedFile, setSelectedFile] = useState("");
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { handleSubmit, reset } = props;
    const setProfilePic = (selectedImg) => {
        console.log("profile image =>>>");
        const selectedFile = selectedImg.files[0];
        setProfileImage(URL.createObjectURL(selectedFile))
        setSelectedFile(selectedFile)
    }
    const submitProfileImg = (e) => {
        e.preventDefault();
        let url = `${process.env.REACT_APP_APP_API_URL}/api/profilepic`
        let formData = new FormData();
        formData.append("photos", selectedFile);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
        return axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                toast.success("Image uploaded Successful!");
                dispatch(reset('sellerForm'));
                navigate('/profile')
            }
        }).catch(e => {
            if (e && e.response && e.response.data.message) {
                toast.error(e.response.data.message);
            }
        })
    }
    useEffect(async () => {
        getUser()
        // setPromoImages(["s", "ss", "sss"])
    }, [])
    const getUser = () => {
        getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
            if (res.data.status) {
                setProfileImage("https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + res.data.user.image);
            }
        }).catch(console.log)
    };
    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="box add">
                        <span className="title">Add a Post</span>
                        <div className="textarea_wrap">
                            <form method="post" action="?action=new_post" id="new_post_form" encType="multipart/form-data" className="fu_form">
                                <input type="hidden" name="action" defaultValue="new_post" />
                                <textarea style={{ display: "none" }} className="default" name="post" id="post" placeholder="What's on your mind?" defaultValue={""} />
                                <div className="fu_wrap single" id="post_file">
                                    <div className="fu_upload">
                                        <span className="fu_replace just_icon">
                                            <input type="file" name="post_file" className="file_uploader no_title active" data-icon="camera" data-number={0} onChange={(e) => setProfilePic(e.target)} />
                                            <span className="data_icon icon-camera" data-id="post_file" />
                                        </span></div>
                                    {/* <div className="fu_status">
                                        <fieldset data-number={0} className="fu_preview no_title" data-id="post_file">
                                            <legend>Preview</legend><ul className="fu_list sortable" />
                                        </fieldset>
                                        <fieldset data-number={0} className="fu_progress" data-id="post_file">
                                            <legend>Progress</legend>
                                        </fieldset>
                                        
                                    </div> */}
                                    <div style={{ marginBottom: "5%" }}>
                                        <CImage style={{ maxWidth: "100%" }} src={profileImg} />
                                    </div>
                                </div>
                                <button onClick={(e) => submitProfileImg(e)} className="timeline_post">Post</button>
                            </form>
                        </div>
                    </div>
                </li>
                <li className="newsfeed_heading">Newsfeed</li>
                <li className="empty_msg no_messages">There haven't been any wall posts for this user yet!  Be the first!</li>
            </ul>
        </>
    )
}